
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marcar-avaliacao",
      function () {
        return require("private-next-pages/marcar-avaliacao.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/marcar-avaliacao"])
      });
    }
  